import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchNl = () => {
    return <AdvancedSearch languageCode="nl" />
}

export default AdvancedSearchNl
